import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { QueryStaleTime } from "@/constants/query-stale-time";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetAllGenerationStatus = () => {
  const { data, refetch, isLoading, error } = useQuery({
    queryKey: [QueryKeys.ALL_GENERATION_STATUS],
    staleTime: QueryStaleTime.ZERO,
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await MealsService.checkAllMealGenerationStatusApiV1MealsAllGenerationStatusGet(
          user.id,
        );
      return data;
    },
  });

  return { allGenerationStatus: data, refetch, isLoading, error };
};
